import React from "react";
import { Button, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Top from "../../Top";
import Left from "../../Left"; 
import AllServiceProvidersNewList from "./AllServiceProvidersNewList";

function NewProvider() {
  const navigate = useNavigate();
  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">New Service Providers</h1>
            <Button
              className="contentTopLefBt addCommiteeBt"
              onClick={() => navigate("/AddServiceProvider")}
            >
              Add Service Provider
            </Button>
          </Grid>
          <Grid item xs={12} md={12}>
            <div className="residentManagementTable">
            <AllServiceProvidersNewList />
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default NewProvider;
